import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Dna } from "lucide-react";
import { api, errText, photoUrl } from "../../lib/api";
import { useLanguage } from "../../context/LanguageContext";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Loader } from "./shared";

export function MyFollowing() {
  const { t } = useLanguage();
  const [items, setItems] = useState(null);
  const load = () => api.get("/my/following").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const unfollow = async (id) => {
    try { await api.delete(`/breeders/${id}/follow`); toast.success(t("lt_unfollow_toast")); load(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <section className="mt-10" data-testid="my-following">
      <h3 className="font-display text-lg font-bold text-[#12234A] flex items-center gap-2 mb-3"><Dna size={18} className="text-purple-600" /> {t("lt_my_following")}</h3>
      {items === null ? <Loader /> : items.length === 0 ? (
        <p className="text-sm text-slate-400">{t("lt_my_following_empty")}</p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-2">
          {items.map((b) => (
            <div key={b.breeder_id} className="bg-white rounded-xl border border-slate-200/80 px-4 py-3 flex items-center gap-3" data-testid={`following-${b.breeder_id}`}>
              <Avatar className="h-9 w-9"><AvatarImage src={photoUrl(b.picture)} /><AvatarFallback className="bg-purple-600 text-white text-xs">{b.name?.[0]}</AvatarFallback></Avatar>
              <div className="flex-1 min-w-0">
                <Link to={`/seller/${b.breeder_id}`} className="text-sm font-semibold text-[#12234A] hover:text-[#F5551E] truncate block">{b.name}</Link>
                <p className="text-[11px] text-slate-500">{t("lt_open_label")}: {b.open_litters}</p>
              </div>
              <button onClick={() => unfollow(b.breeder_id)} data-testid={`unfollow-${b.breeder_id}`} className="text-xs font-semibold text-slate-500 hover:text-red-600">{t("lt_unfollow")}</button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
